angular
	.module('truncatedPopover.components', [])
	.component('truncatedPopover', {
		templateUrl: 'ng/components/truncatedPopover/truncatedPopover.html',
		bindings: {
			inputClass: '@',
			placement: '@',
			extendedContent: '@',
			truncateOn: '='
		},
		controllerAs: 'truncatedPopoverCtrl',
		controller: function TruncatedPopoverCtrl($timeout) {

			var self = this;

			self.$onInit = function () {
				//console.log('truncatedPopoverCtrl', self);
				$timeout(function () {
					self.toggleTooltip();
				}, 2000)
			}

			self.toggleTooltip = function () {

				$('[data-toggle="tooltipPopover"]').tooltip()
			}
		}
	});